/* hej-tips — het gedrag van sections/hej-tips.liquid.
 *
 * Opzet zoals assets/faq-apple.js: een knop met aria-expanded en een klasse is-open op het vak
 * eronder. Een verschil, en dat is met opzet: de hoogte wordt hier door dit script in echte pixels
 * gezet, net als bij de uitlegsectie op de collectiepaginas (assets/hej-uitleg.js).
 *
 * Waarom niet de twee technieken die hier eerder stonden. Hoogte 0 naar auto beweegt alleen waar
 * de browser interpolate-size kent. De rasterrij van 0fr naar 1fr, de techniek van de vragen, kwam
 * bij ons niet lager dan een regel tekst en begon 30 tot 50 ms later te lopen, dus het eerste stuk
 * van de beweging was onzichtbaar. Dat is gemeten op 2026-09-26, beeld voor beeld, en staat in
 * .ai/history/tasks/completed/2026-09/2026-09-26-advies-soepeler-en-koppen-groter.md. Op een breed
 * scherm valt dat op en op mobiel niet, precies wat de gebruiker op 2026-10-05 meldde.
 *
 * Met twee echte getallen als begin- en eindpunt heeft de browser niets uit te rekenen: het begint
 * bij nul, het loopt direct, en het werkt in iedere browser.
 *
 * Na het opengaan gaat de hoogte op auto. Anders houdt een paneel zijn oude pixelhoogte als het
 * venster smaller wordt en de tekst meer regels nodig heeft.
 *
 * De sectie wordt via het scripttag zelf opgezocht en niet via een opzoeking over de hele pagina,
 * zodat de sectie twee keer op een pagina kan staan zonder dat de tweede de eerste bedient.
 */
var __tipsZelf = document.currentScript;
var __tipsWortel = __tipsZelf ? __tipsZelf.parentElement : null;

(function () {
  var sectie = (__tipsWortel && __tipsWortel.querySelector('.hej-tips'))
    || document.querySelector('.hej-tips:not([data-tips-gereed])');
  if (!sectie || sectie.hasAttribute('data-tips-gereed')) return;
  sectie.setAttribute('data-tips-gereed', '');

  var items = sectie.querySelectorAll('.hej-tips__vouw');
  var sluitAnderen = sectie.getAttribute('data-sluit-anderen') !== 'false';

  /* Met animaties uit staat er geen overgang, dus komt er ook geen transitionend. Dan zetten we de
     hoogte meteen op auto, anders houdt het paneel voorgoed de pixelhoogte van dat ene moment. */
  function rustigeBeweging() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function openItem(vouw, knop, vak) {
    var hoogte = vak.scrollHeight;
    knop.setAttribute('aria-expanded', 'true');
    vouw.classList.add('is-open');
    vak.classList.add('is-open');
    vak.style.height = rustigeBeweging() ? 'auto' : hoogte + 'px';
  }

  function sluitItem(vouw, knop, vak) {
    if (knop.getAttribute('aria-expanded') !== 'true') return;
    /* Van auto naar een getal, dan een herberekening forceren, en dan naar nul. Zonder die
       tussenstap heeft de browser geen beginwaarde om vanaf te lopen en klapt het dicht. */
    vak.style.height = vak.scrollHeight + 'px';
    void vak.offsetHeight;
    knop.setAttribute('aria-expanded', 'false');
    vouw.classList.remove('is-open');
    vak.classList.remove('is-open');
    vak.style.height = '0px';
  }

  Array.prototype.forEach.call(items, function (vouw) {
    var knop = vouw.querySelector('.hej-tips__knop');
    var vak = vouw.querySelector('.hej-tips__uit');
    if (!knop || !vak) return;
    var raakStartY = 0;

    /* Zodra het opengaan klaar is mag de hoogte weer los, zodat het paneel meegroeit als de tekst
       op een smaller venster meer regels nodig heeft. */
    vak.addEventListener('transitionend', function (e) {
      if (e.propertyName !== 'height') return;
      if (vak.classList.contains('is-open')) vak.style.height = 'auto';
    });

    function wissel(e) {
      e.preventDefault();
      var staatOpen = knop.getAttribute('aria-expanded') === 'true';

      if (sluitAnderen) {
        Array.prototype.forEach.call(items, function (ander) {
          if (ander === vouw) return;
          var anderKnop = ander.querySelector('.hej-tips__knop');
          var anderVak = ander.querySelector('.hej-tips__uit');
          if (anderKnop && anderVak) sluitItem(ander, anderKnop, anderVak);
        });
      }

      if (!staatOpen) openItem(vouw, knop, vak);
      else sluitItem(vouw, knop, vak);
    }

    knop.addEventListener('click', wissel);
    knop.addEventListener('touchstart', function (e) {
      raakStartY = e.touches[0].clientY;
    }, { passive: true });
    knop.addEventListener('touchend', function (e) {
      /* Bij scrollen mag een aanraking de balk niet openen. */
      if (Math.abs(e.changedTouches[0].clientY - raakStartY) > 8) return;
      e.preventDefault();
      wissel(e);
    }, { passive: false });
  });
})();
